import { useNavigate } from 'react-router-dom';
import SimulationIcon from 'src/app/images/icons/simulation-icon';
import { FiClipboard, FiInfo } from 'react-icons/fi';
import { FiStar } from 'react-icons/fi';
import { VscGame } from 'react-icons/vsc';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, A11y } from 'swiper/modules';
import { Disclaimer, DisclaimerContent, DisclaimerIcon, DisclaimerText, DisclaimerTitle, DisclaimerWrapper } from '@/components/custom/disclaimer';

function DisclaimerCard({ item }) {
  const navigate = useNavigate();

  const icon = type => {
    switch (type) {
      case 'challenge':
        return <VscGame />;
      case 'project':
        return <FiClipboard />;
      case 'survey':
        return <FiStar />;
      case 'exam':
        return <SimulationIcon />;
      case 'info':
        return <FiInfo />;
      default:
        return null;
    }
  };

  if (!item?.['access_url']) return null;

  return (
    <Disclaimer onClick={() => navigate(item.type === 'challenge' ? '/desafio-da-semana/desafios' : item?.['access_url'] ? item?.['access_url'] : '/')}>
      <DisclaimerIcon>{icon(item.type)}</DisclaimerIcon>

      <DisclaimerContent>
        <DisclaimerTitle title={item?.name}>{item?.name}</DisclaimerTitle>
        <DisclaimerText title={item?.description}>{item?.description}</DisclaimerText>
      </DisclaimerContent>
    </Disclaimer>
  );
}

export function DashboardDisclaimer({ alerts }) {
  if (alerts?.length === 0 || alerts?.every(alert => alert?.['access_url'] === null)) return null;

  if (alerts?.length === 1) {
    const item = alerts[0];

    return (
      <DisclaimerWrapper>
        <DisclaimerCard item={item} />
      </DisclaimerWrapper>
    );
  }

  return (
    <DisclaimerWrapper>
      <Swiper
        pagination={{ clickable: true }}
        modules={[Pagination, A11y]}
        spaceBetween={10}
        slidesPerView={1.5}
        style={{ paddingBottom: alerts?.length > 1 ? 22 : 0 }}
      >
        {alerts?.map((item, i) => {
          if (item?.['access_url'])
            return (
              <SwiperSlide key={i}>
                <DisclaimerCard item={item} />
              </SwiperSlide>
            );
        })}
      </Swiper>
    </DisclaimerWrapper>
  );
}
